// @ts-nocheck
import * as React from "react";

const BellOffLine: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M5.28 8.11l2 2v3.29a2 2 0 01-.59 1.42L5.51 16h7.66l.83.86L15.17 18l.83.78A3.88 3.88 0 0112 22l-.197.003A3.84 3.84 0 018 18.34V18H4.64a1.63 1.63 0 01-1.16-2.79l1.8-1.81V8.7a5.68 5.68 0 010-.59zM3.29 3.29a1.004 1.004 0 011.42 0l3.18 3.18L17.41 16l2 2 1.3 1.29a1.002 1.002 0 010 1.42l-.003.003a1 1 0 01-1.417-.003L16.59 18l-2-2-7.31-7.3L5.53 7 3.29 4.71l-.084-.095A1.004 1.004 0 013.29 3.29zM14 18h-4v.34A1.88 1.88 0 0012 20l.15.005A1.88 1.88 0 0014 18.34V18zM7.802 3.483A6.71 6.71 0 0112.9 2.06l.235.04a6.86 6.86 0 015.585 6.84v4.46l1.8 1.81c.47.466.608 1.17.35 1.78l-.066.136a1.58 1.58 0 01-.384.464l-3.6-3.6a1.92 1.92 0 01-.1-.59V8.68A4.86 4.86 0 0012.64 4l-.255-.026A4.67 4.67 0 008.9 5.17l-.15.15a4.79 4.79 0 00-.28.32L7 4.21a6.88 6.88 0 01.58-.54z"
                fill="currentColor"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default React.memo(BellOffLine);
